module.exports = __webpack_public_path__ + "img/lookbook_14_right.5064a531.png";